/* eslint-disable */
import * as moment from 'moment';

export const notifications = [
  // {
  //   id: '493190c9-5b61-4912-afe5-78c21f1044d7',
  //   icon: 'heroicons_solid:star',
  //   title: 'Notificaciones diarias',
  //   description: 'Tu solicitud de crédito ha sido aceptada',
  //   time: moment().subtract(25, 'minutes').toISOString(), // 25 minutes ago
  //   read: false
  // },

  // {
  //   id: 'b91ccb58-b06c-413b-b389-87010e03a120',
  //   icon: 'heroicons_solid:mail',
  //   title: 'Mensaje ',
  //   description: 'Tiene 15 mensajes no leídos de tu ejecutivo',
  //   time: moment().subtract(3, 'hours').toISOString(), // 3 hours ago
  //   read: false,
  //   // link: '/dashboards/project',
  //   // useRouter: true
  // },
  // {
  //   id: '541416c9-84a7-408a-8d74-27a43c38d797',
  //   icon: 'heroicons_solid:refresh',
  //   title: 'Emisoras',
  //   description: 'Sus <em>emisoras</em> están listas para vender',
  //   time: moment().subtract(5, 'hours').toISOString(), // 5 hours ago
  //   read: false,
  //   // link: '/dashboards/project',
  //   // useRouter: true
  // },

  // {
  //   id: 'b85c2338-cc98-4140-bbf8-c226ce4e395e',
  //   icon: 'heroicons_solid:mail',
  //   title: 'Mensajes',
  //   description: 'Tienes 3 nuevos mensajes',
  //   time: moment().subtract(1, 'day').toISOString(), // 1 day ago
  //   read: false,
  //   // link: '/dashboards/project',
  //   // useRouter: true
  // }, {
  //   id: '8f8e1bf9-4661-4939-9e43-390957b60f42',
  //   icon: 'heroicons_solid:star',
  //   title: 'Notificaciones diarias',
  //   description: 'Su envío ha sido aceptado y está listo para registrarse para la asignación final, que estará lista en 2 días.',

  //   time: moment().subtract(3, 'days').toISOString(), // 3 days ago
  //   read: true,
  //   // link: '/dashboards/project',
  //   // useRouter: true
  // },
  
  // {
  //   id: '30af917b-7a6a-45d1-822f-9e7ad7f8bf69',
  //   icon: 'heroicons_solid:refresh',
  //   title: 'Emisoras',
  //   description: 'Hay una nueva lista de emisora que podría interesarte',
  //   time: moment().subtract(4, 'day').toISOString(), // 4 days ago
  //   read: false,
  //   // link: '/dashboards/project',
  //   // useRouter: true
  // }
];
